/* eslint-disable */
export const CURRENCIES = {
  GB: {
    name: 'British pound sterling',
    short_name: 'GBP',
    symbol: '£',
    round_prices: false,
  },
  IN: {
    name: 'Indian Rupee',
    short_name: 'INR',
    symbol: '₹',
    round_prices: true,
  },
};

export const CURRENCIES_SHORTNAME_TO_COUNTRY_ID = {
  INR: 'IN',
  GBP: 'GB',
};

export const DURATIONS = {
  DEFAULT: 'default',
  MONTHLY: 'month',
  YEARLY: 'year',
};

export const PACKAGE_ID = 'fonetti-premium-library';
export const DEFAULT_MANAGE_SUBSCRIPTION_MESSAGE = 'This subscription is pending renewal - You need to add a new payment card.';
